export default __webpack_public_path__ + "static/media/pink.a06f67b1.ogg";